import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export const LoadingWrapper = ({
loadingTitle,
  isLoading,
  isError,
  children,
  testId
}: {
  loadingTitle:string;
  isLoading: boolean;
  isError: boolean;
  children: ReactNode;
  testId?:string
}) => {
  const { t } = useTranslation();
  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center py-10"
       data-test-id={testId}>
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-blue-500 border-t-transparent"></div>
        <p className="mt-4 text-blue-500 font-medium">{loadingTitle}</p>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="flex flex-col items-center justify-center py-10">
        <p className="text-red-500 font-medium">{t("FailedToLoad")}</p>
      </div>
    );
  }

  return <>{children}</>;
};
